<script>
import { VStepperStep } from 'vuetify/lib';
export default VStepperStep;
</script>
